import Registeration from './components/Registeration/Registeration.vue'
export default [
  {
    path : '/',
    component : Registeration,
  },
]


// WEBPACK FOOTER //
// ./src/routes.js